import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './DanceDetailsComponent.metadata.json5';

import styles from '../../../SpaAndWellCommonStyles.module.scss';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function DanceDetailsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('DanceDetailsComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;


    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        onAveHowmanStuatttRecFie: {
            visible: !_.isUndefined(modelVM.value.howmanRecdoyouattpyeaFie) && modelVM.value.howmanRecdoyouattpyeaFie > 0
        },
        howmanRecarehelatyStuFie: {
            visible: !_.isUndefined(modelVM.value.howmanRecdoyouattpyeaFie) && modelVM.value.howmanRecdoyouattpyeaFie > 0
        },
        howmanRecarehelawaStuFie: {
            visible: !_.isUndefined(modelVM.value.howmanRecdoyouattpyeaFie) && modelVM.value.howmanRecdoyouattpyeaFie > 0
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

DanceDetailsComponent.propTypes = wizardProps;
export default withRouter(DanceDetailsComponent);
